import styled from "styled-components";

export const EventsPageContainer = styled.div`
  padding: 0px 4% 4% 4%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  @media (max-width: 600px) {
    padding: 0 10px;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 5px;
  padding: 5px 0;
  right: 0;
  z-index: 1000;
`;

export const DropdownItem = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  color: #333;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1.5px solid #fe2f67;
  padding: 1.5% 0;
`;

export const TopBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const CountLabel = styled.span`
  font-size: 15px;
  color: #fe2f67;
  font-weight: lighter;
`;

export const FilterIconContainer = styled.div`
  cursor: pointer;
  margin-top: 5px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 22rem;
  background: #fff;
  border-radius: 0.7rem;
  box-shadow: 0 0.1rem 0.3rem rgba(254, 47, 103, 0.07);
  border: 1.5px solid #fe2f67;
  margin-left: 1.5rem;
  
  .search-input-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    height: 2rem;
    background: transparent;
    padding: 0 1.2rem 0 2.2rem;
  }

  input {
    width: 100%;
    height: 100%;
    border: none !important;
    outline: none !important;
    font-size: 1rem;
    color: #222;
    background: transparent;
    border-radius: 0.7rem;
    transition: background 0.2s, border 0.2s;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
    display: block;
  }

  input:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent;
  }

  input::placeholder {
    color: #fe2f67;
    opacity: 0.7;
    font-size: 1rem;
  }

  .search-icon {
    position: absolute;
    left: 0.8rem;
    top: 50%;
    transform: translateY(-50%);
    color: #fe2f67;
    font-size: 1.2rem;
    pointer-events: none;
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const PinkBarContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const EventsListHeader = styled.div`
  background: #fe2f67;
  color: #fff;
  padding: 10px 15px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
`;

export const ArrowIcon = styled.div<{ isOpen: boolean }>`
  margin-left: 8px;
  cursor: pointer;
  svg {
    transition: transform 0.3s;
    transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  }
`;

export const EventsWrapper = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const EventsColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border-radius: 8px 0 0 8px;
  justify-content: space-between;

  @media (max-width: 900px) {
    width: 100%;
    border-radius: 8px;
  }
`;

export const EventsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-height:800px;
`;

export const EventItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 50px;
  padding: 15px;
  cursor: pointer;
  height: 150px;
  background-color: #fff1f1;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }

  &.selected {
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 8px;
      height: 100%;
      background-color: #fe2f67;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  @media (max-width: 600px) {
    gap: 15px;
    height: auto;
  }
`;

export const EventImageContainer = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 14px;

  @media (max-width: 600px) {
    width: 80px;
    height: 80px;
  }
`;

export const EventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  justify-content: center;
  text-align: left;
  height: 100%;

  @media (max-width: 600px) {
    margin-left: 0;
  }
`;

export const EventName = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 10px 0;
`;

export const EventTime = styled.p`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #757575;
  font-weight: 600;
  margin: 0 0 5px 0;
`;

export const EventLocation = styled.p`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #757575;
  margin: 0;
  font-weight: 600;
`;

export const EventDetailWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 0 8px 8px 0;
  overflow: hidden;

  @media (max-width: 900px) {
    width: 100%;
    border-radius: 8px;
    margin-top: 10px;
  }
`;

export const EventDetailBannerContainer = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
  font-size: 14px;
`;

export const DetailBanner = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const EditEventButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #fe2f67;
  border: 2px solid #fe2f67;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  svg {
    color: #fe2f67;
  }

  &:hover {
    background: #fe2f67;
    color: #fff;
  }

  &:hover svg {
    color: #fff;
  }
`;

export const EventDetailContent = styled.div`
  margin: 0;
  padding: 20px; /* antes: 10px 40px */

  @media (max-width: 600px) {
    padding: 15px;
  }
`;

export const EventDetailExtraHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const DraftLabel = styled.span`
  font-size: 14px;
  color: #757575;
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;

  display: inline-block;
  align-self: flex-start;
  width: auto;
  max-width: fit-content;
  font-weight: bold;
`;
export const NameAndDraftContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* Ajusta margen si necesitas separar más el draft label */
  gap: 4px;
`;

export const EventDetailName = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;

export const DetailButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const AttendButton = styled.button`
  background: none;
  border: 2px solid #fe2f67;
  color: #fe2f67;
  padding: 8px 24px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: #fe2f67;
    color: #fff;
  }
`;

export const RequestCollabLink = styled.span`
  font-size: 14px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #666;
  }
`;

export const DetailSubtitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
`;

export const EventDetailBody = styled.p`
  font-size: 14px;
  color: black;
  margin: 15px 0px 30px 0px;
  line-height: 1.5;
`;

export const DetailInfoLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-size: 14px;
  color: black;
  font-weight: 400;
`;

export const AttendeesContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    justify-content: center;
  }
`;

export const Attendee = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #555;
  cursor: pointer;

  &:hover {
    color: #fe2f67;
    .avatar {
      box-shadow: 0 0 0 2px #fe2f67;
    }
  }
`;

export const AttendeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 5px;
`;

export const CreateNewEvent = styled.div`
  color: #fe2f67;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  align-items: center;

  &::before {
    content: "+";
    font-size: 18px;
    margin-right: 6px;
  }

  @media (max-width: 850px) {
    width: 100%;
    padding: 10px;
  }
`;

export const NoEventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;

  img {
    max-width: 175px;
  }

  h2 {
    font-size: 1rem;
    font-weight: normal;
    color: #333;
  }
`;
export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  position: relative;
  background: #fff;
  width: 600px;
  max-width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  margin: 2rem 0;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }


  &::-webkit-scrollbar {
    width: 6px; 
    background: none; 
  }
  &::-webkit-scrollbar-button {
    display: none; 
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 0.5rem 0; 
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc; 
    border-radius: 4px; 
    border: 1px solid #fff; 
    &:hover {
      background-color: #aaa;
    }
  }

  scrollbar-width: none
  scrollbar-color: #ccc transparent; 
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #aaa;

  &:hover {
    color: #777;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  margin: 0 0 1rem;
  text-align: center;
`;

export const ModalLoading = styled.div`
  text-align: center;
  padding: 2rem;
  font-size: 16px;
  color: #666;
`;

export const ModalError = styled.div`
  text-align: center;
  padding: 2rem;
  font-size: 16px;
  color: red;
`;

export const ModalImage = styled.img`
  width: 100%;
  max-height: 300px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1rem;
  display: block;
`;

export const ImpactTabContainer = styled.div`
  padding: 1.5rem;
  /* If a background color for page is needed, it can be set here (e.g., light gray) */
`;

export const SectionCard = styled.div`
  background: #fff;
  border-radius: 8px;
  margin-bottom: 2rem;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

// Subsection title (for smaller headings inside a section, e.g., "Participants", "Collaborators")
export const SubSectionTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 1.5rem 0 0.5rem 0;
`;

// Minor title (for even smaller headings, e.g., "Top Invitees")
export const MinorTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem 0;
`;

// Two-column grid (responsive) for placing charts side by side (Participants vs Collaborators)
export const TwoColumnGrid = styled.div`
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// Legend styles for charts
export const LegendList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0;
`;
export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
`;
export const LegendDot = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 0.5rem;
`;
export const LegendLabel = styled.span`
  color: #000;
  font-weight: 500;
`;
export const LegendValue = styled.span`
  color: #555;
  margin-left: 0.25rem;
`;

// Top Invitees (container and item styles)
export const InviteesList = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 1.2rem;
`;
export const InviteeCard = styled.div`
  text-align: center;
  font-size: 0.9rem;
`;
export const InviteeImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;
export const InviteeName = styled.div`
  margin-top: 0.25rem;
`;

// Progress bar styles
export const ProgressBarContainer = styled.div`
  margin: 0.5rem 0;
`;
export const ProgressBarLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
  color: #555;
`;
export const ProgressBarBackground = styled.div`
  background: #f0f0f0;
  height: 8px;
  width: 100%;
  border-radius: 4px;
`;
export const ProgressBarFill = styled.div<{ $width: number; $color: string }>`
  width: ${(props) => props.$width}%;
  background: ${(props) => props.$color};
  height: 8px;
  border-radius: 4px;
  transition: width 0.3s ease;
`;

// Engagement section styles
export const EngagementHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    /* Add spacing between stacked items */
    & > *:not(:first-child) {
      margin-top: 1rem;
    }
  }
`;
export const DonutChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
`;
export const CenteredLabel = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;
export const CenteredLabelTitle = styled.div`
  font-size: 0.9rem;
  color: #555;
`;
export const CenteredLabelValue = styled.div`
  font-size: 1.25rem;
  font-weight: 600;
  color: #000;
`;
export const InsightContainer = styled.div`
  display: flex;
  justify-content: center; /* centrado */
  flex-wrap: wrap; /* responsive */
  gap: 1rem;
  margin: 1rem 0;
`;

/* tarjeta individual */
export const InsightItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  background: #fff1f6;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fe2f67;
  cursor: default;
  transition: color 0.25s;
  svg {
    font-size: 1rem;
    color: #fe2f67;
    transition: color 0.25s;
  }

  &:hover {
    background: #fff1f6;
    color: #d82c89;
    svg {
      color: #d82c89;
    }
  }
`;

export const UpcomingEventTitle  = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  position: relative;
`;